// Dependencies
import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Alert from '../../Alert';
import CircularProgress from '@mui/material/CircularProgress';
import TableComponent from '../../TableComponent';
import SectionTitle from '../../SectionTitle';
import OrderCard from '../../OrderCard';

// Styles
import styles from './index.module.sass';
import getEstadoCuenta from '../../Queries/getEstadoCuenta';
import getEstadoCuenta_PedidosPendientes from '../../Queries/getEstadoCuenta_PedidosPendientes';

const AccountStatus = (props) => {
  const { device, getCookie, setSessionMessage } = props;
  const { screenSize } = device;
  const { t } = useTranslation('accountstatus');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState([]);
  const [pendingOrders, setPendingOrders] = useState([]);

  const movementsItems = t('movements', { returnObjects: true });
  const pendingOrdersItems = t('pendingOrders', { returnObjects: true });

  const getEstadoCuentaFunction = useCallback(async () => {
    setLoading(true);
    const kit = getCookie('usuarioOk');
    const response = await getEstadoCuenta({ kit });
    const {
      tipoMensaje = 'error',
      movimientosMes1 = [],
      movimientosMes2 = [],
      movimientosMes3 = [],
      mensaje = '',
    } = response;

    const movements = movimientosMes1.concat(movimientosMes2).concat(movimientosMes3);

    if (mensaje !== '' || tipoMensaje === 'error') {
      setAlertText(mensaje);
      setOpen(true);
    } else {
      setStatus(movements);
    }

    setLoading(false);
  }, [getCookie]);

  const getEstadoCuentaPedidosFunction = useCallback(async () => {
    setLoading(true);
    const kit = getCookie('usuarioOk');
    const responsePedidos = await getEstadoCuenta_PedidosPendientes({ kit });
    const { tipoMensaje = 'error', pedidos = [], mensaje = '' } = responsePedidos;

    setSessionMessage(mensaje);

    if (mensaje !== '' || tipoMensaje === 'error') {
      setAlertText(mensaje);
      setOpen(true);
    } else {
      setPendingOrders(pedidos);
    }

    setLoading(false);
  }, [getCookie, setSessionMessage]);

  useEffect(() => {
    getEstadoCuentaFunction();
    getEstadoCuentaPedidosFunction();
  }, [getEstadoCuentaFunction, getEstadoCuentaPedidosFunction, t]);

  return (
    <div id={styles.Notices} className={`${styles[screenSize]} ${styles.accountstatus}`}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <SectionTitle title={t('title')} subtitle={t('subtitle')} />
      <div className={styles.container}>
        <OrderCard>
          <div className={styles.tabletitle}>{t('movementsTitle')}</div>
          {(loading && <CircularProgress className={styles.circularProgress} />) || (
            <TableComponent
              screenSize={screenSize}
              tableData={status}
              tableItems={movementsItems}
            />
          )}
        </OrderCard>
        <OrderCard>
          <div className={styles.tabletitle}>{t('pendingOrdersTitle')}</div>
          {(loading && <CircularProgress className={styles.circularProgress} />) || (
            <TableComponent
              screenSize={screenSize}
              tableData={pendingOrders}
              tableItems={pendingOrdersItems}
            />
          )}
        </OrderCard>
      </div>
    </div>
  );
};

export default AccountStatus;
